export default __webpack_public_path__ + "static/media/1002.5f40240e.png";